import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { ProductImage } from '../../../ProductImage'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

import '@loyal_template/cart.css'
import '@loyal_template/confirmation.css'

const DetailCreditMileage = props => (
  <div className='cart-item row align-items-center h-100 px-2 border-color-ui-3 border-bottom py-2'>
    <div className='cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'>
      <ProductImage
        imageUrl={props.imageUrl}
        alt={''}
        vendorId={props.vendorId}
        ready
      />
    </div>
    <div className='cart-product-info col'>
      <div className='cart-product-info row align-items-center h-100'>
        <div className='col-12 col-md-8'>
          <div className='row'>
            <div className='order-number col-12 mx-0 mb-1'>
              <p className='txt-font-body txt-body'>
                Pedido: #{props.parentOrderId}
              </p>
            </div>
            <div className='product-infos col-12 mx-0'>
              <h2 className='txt-body-sm txt-font-body color-ui-2 '>
                Transferência de pontos para {props.vendorName}
              </h2>
            </div>
          </div>
          <div className='row card-price-item  mt-1'>
            <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
              Valor: <CatalogCurrencyLabel value={props.sellingPrice} />
            </div>
            <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
              Realizado em:{' '}
              <strong>
                {props.orderDate
                  ? moment
                    .utc(props.orderDate)
                    .format('DD/MM/YYYY [às] HH[h]mm')
                  : ''}
              </strong>
            </div>
          </div>
        </div>
        <div className='col'>
          <Link
            id='order-detail'
            className='btn btn-sm btn-featured btn-cart txt-center'
            to={`/order/${props.parentOrderId}/${props.orderId}/product/${
              props.itemId
            }`}
          >
            Ver detalhes
          </Link>
        </div>
      </div>
    </div>
  </div>
)

DetailCreditMileage.propTypes = {
  vendorName: PropTypes.string,
  orderDate: PropTypes.objectOf(typeof date),
  sellingPrice: PropTypes.number,
  parentOrderId: PropTypes.number,
  vendorId: PropTypes.number,
  orderId: PropTypes.number,
  itemId: PropTypes.number,
  imageUrl: PropTypes.string
}

export default DetailCreditMileage



// WEBPACK FOOTER //
// ./src/features/Services/ConfirmationCreditMileage/AboutCreditMileage/DetailCreditMileage.js